import { useState } from "react";

export function PortalLogin({ onLogin }) {
  const [ref, setRef] = useState("");
  const [email, setEmail] = useState("");
  return (
    <main data-testid="portal-login-page" className="px-6 md:px-12 lg:px-16 pt-16 pb-24 max-w-xl">
      <div className="label-eyebrow mb-6">Client Portal</div>
      <h1 className="font-black tracking-tighter leading-[0.95] text-5xl md:text-6xl">Sign in.</h1>
      <p className="mt-6 text-[#6B7280]">Use the booking reference we emailed you, plus the email address you used at checkout.</p>
      <div className="de-card p-8 mt-10 space-y-4">
        <div>
          <label className="label-eyebrow block mb-2">Booking reference</label>
          <input data-testid="portal-ref-input" value={ref} onChange={e=>setRef(e.target.value)} placeholder="TEW-XXXXXXXX" className="w-full border border-[#E5E7EB] bg-white px-4 py-3 uppercase"/>
        </div>
        <div>
          <label className="label-eyebrow block mb-2">Email</label>
          <input data-testid="portal-email-input" type="email" value={email} onChange={e=>setEmail(e.target.value)} className="w-full border border-[#E5E7EB] bg-white px-4 py-3"/>
        </div>
        <button data-testid="portal-login-btn" onClick={()=>onLogin(ref, email)} className="de-btn-primary w-full">Sign in</button>
      </div>
    </main>
  );
}
